// extracted by mini-css-extract-plugin
export default {"spacingTypeOfList":"InfoStep_spacingTypeOfList__0YGib"};